import { StandardEvents } from '@shopify/events';

function initCartRecommendations(scope = document) {
  scope.querySelectorAll('.cart-recommendations').forEach((container) => {
    container._sliderInitialized = false;
if (!container) return;
    const slider = container.querySelector('.cart-recommendations-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.cart-recommendation-slide');

    if (slides.length <= 1) return;

    let index = 0;

    const goTo = (i) => {
      index = i;

      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slider.scrollTo({
        left: slides[index].offsetLeft,
        behavior: 'smooth',
      });
    };

    container.addEventListener('click', (e) => {
      if (e.target.closest('.cart-recommendations-arrow--next')) {
        goTo(index + 1);
      }

      if (e.target.closest('.cart-recommendations-arrow--prev')) {
        goTo(index - 1);
      }
    });

    slider.addEventListener('scroll', () => {
      index = Math.round(slider.scrollLeft / slider.clientWidth);
    });
  });
}

const observer = new MutationObserver(() => {

  setTimeout(() => {
    initCartRecommendations(document);
  }, 50);

});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener('DOMContentLoaded', () => {
  initCartRecommendations();
});

function getQuickAddElements() {
  return {
    quickAdd: document.querySelector('.cart-quick-add'),
    quickAddContent: document.querySelector('#cart-quick-add-content'),
    quickAddClose: document.querySelector('.cart-quick-add__close'),
    quickAddOverlay: document.querySelector('.cart-quick-add__overlay'),
  };
}

function closeQuickAdd() {
  const { quickAdd, quickAddContent } = getQuickAddElements();

  if (!quickAdd) return;

  quickAdd.hidden = true;
  quickAddContent.innerHTML = '';
}

function convertVariantButtonsToDropdowns(container) {
  container.querySelectorAll('.variant-option--buttons').forEach((fieldset) => {
    if (fieldset.querySelector('.variant-option__select')) return;

    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];

    if (!radios.length) return;

    const select = document.createElement('select');

    select.className = 'variant-option__select';

    radios.forEach((radio) => {
      radio.hidden = true;

      const option = document.createElement('option');

      option.value = radio.value;
      option.textContent = radio.value;
      option.dataset.optionValueId = radio.dataset.optionValueId;

      if (radio.checked) {
        option.selected = true;
      }

      select.appendChild(option);
    });

    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];

      const radio = radios.find(
        (r) => r.dataset.optionValueId === option.dataset.optionValueId
      );

      if (!radio) return;

      radio.checked = true;

      radio.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    });

    fieldset.appendChild(select);
  });
}

function convertSingleVariantToDropdown(container) {
  container
    .querySelectorAll('[data-testid="variant-option-single"]')
    .forEach((option) => {

      if (option.querySelector('select')) return;

      const value = option.querySelector('.variant-option__swatch-value');

      if (!value) return;

      const label = option.childNodes[0]?.textContent.trim() || '';

      const select = document.createElement('select');
      select.className = 'variant-option__select';

      const opt = document.createElement('option');
      opt.value = value.textContent.trim();
      opt.textContent = value.textContent.trim();

      select.appendChild(opt);

      option.innerHTML = '';

      if (label) {
        const labelNode = document.createElement('label');
        labelNode.textContent = label;
        option.appendChild(labelNode);
      }

      option.appendChild(select);
    });
}


function observeVariantPicker(container) {
  const picker = container.querySelector('variant-picker');

  if (!picker) return;

  const observer = new MutationObserver(() => {
    convertVariantButtonsToDropdowns(container);
convertSingleVariantToDropdown(container);
  });

  observer.observe(picker, {
    childList: true,
    subtree: true,
  });
}

async function openQuickAdd(button) {
  const { quickAdd, quickAddContent } = getQuickAddElements();

  if (!quickAdd || !quickAddContent) {
    console.error('No existe cart quick add');
    return;
  }

  const recommendationCard = button.closest('.cart-recommendation-product');

  const url = new URL(button.dataset.productUrl, window.location.origin);

  url.searchParams.set('cart_quick_add', 'true');

  const response = await fetch(url);

  const html = await response.text();

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const productContent = doc.querySelector('[data-product-grid-content]');

  if (!productContent) {
    console.error('No se encontró product grid content');
    return;
  }


  // limpiamos
  quickAddContent.innerHTML = '';


  // agregamos primero la tarjeta del producto recomendado
  if (recommendationCard) {
    const clone = recommendationCard.cloneNode(true);

    // quitamos el botón viejo porque no queremos duplicarlo
    const oldButton = clone.querySelector('.cart-recommendation-add');

    if (oldButton) {
      oldButton.remove();
    }

    quickAddContent.appendChild(clone);
  }


  // agregamos variantes
  quickAddContent.appendChild(
    productContent.cloneNode(true)
  );


 


  convertVariantButtonsToDropdowns(quickAddContent);
  convertSingleVariantToDropdown(quickAddContent);
  observeVariantPicker(quickAddContent);


  quickAdd.hidden = false;

  quickAddContent.addEventListener('submit', () => {
  setTimeout(() => {

    const error = quickAddContent.querySelector(
      '.product-form-text__error:not(.hidden)'
    );

    if (error) {
      console.log('Error de cantidad, mantener abierto');
      return;
    }

    closeQuickAdd();

  }, 800);
});
}

document.addEventListener('click', (e) => {
  if (e.target.closest('.cart-quick-add__close')) {
    closeQuickAdd();
  }

  if (e.target.closest('.cart-quick-add__overlay')) {
    closeQuickAdd();
  }
});

document.addEventListener('click', async (e) => {
  const button = e.target.closest('.cart-recommendation-add');

  if (!button) return;

  if (button.dataset.hasVariants === 'true') {
    openQuickAdd(button);
    return;
  }

  button.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: button.dataset.variantId,
            quantity: 1,
          },
        ],
      }),
    });

    const cart = await response.json();

    const sections = await fetch('/?sections=cart-drawer-section').then((r) =>
      r.json()
    );

    const html = sections['cart-drawer-section'];

    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newInner = doc.querySelector('.cart-drawer__inner');
      const currentInner = document.querySelector('.cart-drawer__inner');

      if (newInner && currentInner) {
        currentInner.replaceWith(newInner);

        requestAnimationFrame(() => {
          initCartRecommendations(document);
        },100);
      }
    }

    document.dispatchEvent(
      new CustomEvent(StandardEvents.cartLinesUpdate, {
        detail: {
          action: 'add',
          itemCount: cart.items.length,
        },
      })
    );

    
  } catch (error) {
    console.error(error);
  }

  button.disabled = false;
});